import { AfterContentChecked, ChangeDetectorRef, Component, Input } from '@angular/core';
import { GraphWidget, HeaderParams } from '@wb/core/interfaces/widget';
import { DisplayService } from './../../../core/services/display.service';

@Component({
  selector: 'app-graph-header',
  templateUrl: './graph-header.component.html',
  styleUrls: ['./graph-header.component.sass'],
})
export class GraphHeaderComponent implements AfterContentChecked {
  @Input() widget?: GraphWidget;

  @Input() headerMaxWidth?: string = '150px';

  constructor(private changeDetectorRef: ChangeDetectorRef, public readonly displayService: DisplayService) {}

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  getTooltip(div: HTMLDivElement, widget?: GraphWidget, headerKey?: string): string {
    if (widget && widget.headers && headerKey) {
      const headers = widget.headers;
      const key = headerKey as keyof HeaderParams;
      const header = headers[key];
      const tooltipOverrides = headers.TooltipOverrides ? headers.TooltipOverrides[headerKey] : null;

      return this.setTooltip(div, Array.isArray(header) ? header.join('\r\n') : header, tooltipOverrides);
    }

    return '';
  }

  setTooltip(div: HTMLDivElement, tooltip?: string, tooltipOverride?: string): string {
    const labelText = div.children.item(1);
    const maxWidth = Number.parseInt(this.headerMaxWidth?.match(/\d+/g)?.[0] ?? '0');

    // If the text of the label is within the max width, don't show a tooltip. Unless the tooltip has an override, then do show it
    if (labelText && labelText.scrollWidth < maxWidth && !tooltipOverride) {
      return '';
    }

    return tooltipOverride ?? tooltip ?? '';
  }
}
